import { Controller } from "@hotwired/stimulus"

// Quantity stepper for the theme's "input-spin" component.
export default class extends Controller {
  static targets = ["input"]

  increment() {
    const input = this.inputTarget
    const step = parseInt(input.step, 10) || 1
    input.value = (parseInt(input.value, 10) || 0) + step
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }

  decrement() {
    const input = this.inputTarget
    const step = parseInt(input.step, 10) || 1
    const min = input.min === "" ? -Infinity : parseInt(input.min, 10)
    const next = (parseInt(input.value, 10) || 0) - step
    input.value = Math.max(next, min)
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
